import React, { lazy } from 'react'
import { BiSupport } from "react-icons/bi";
import lazyComponent from './lazy'
import SupportComponent from 'containers/Support';


const Component: React.FC = () => <div>Testing</div>

const Support = [
  {
    key: 'view_RU',
    url: 'support',
    name: 'App.Support',
    roles: ['ADMIN'],
    title: 'Soporte',
    views: {
      'main@App': { component: lazyComponent(SupportComponent) }
    },
    data: {
      nav: {
        type: 'menu',
        sort: Number.MAX_SAFE_INTEGER - 2,
        icon: <BiSupport />,
        roles: []
      }
    }
  }
]

export default Support
